import { createFileRoute } from "@tanstack/react-router";
import BhojanshalaPage from "@project/user/pages/programs/bhojanshala";

export const Route = createFileRoute("/_user/_programs/bhojanshala")({
  head: () => ({ meta: [{ title: "Bhojanshala — Jivandhara" }] }),
  component: BhojanshalaPage,
});
